import { Injectable } from '@angular/core';
import { GoogleMap } from '@capacitor/google-maps';
import { WebViewService } from 'src/app/services/webview-background/webview.service';
import { ThemeWrapper } from 'src/app/wrappers/theme.wrapper';
import { GoogleMapsModule } from '../modules/google-maps.module';

@Injectable({
  providedIn: GoogleMapsModule
})
export class GoogleMapsShutdownControllerFactory {
  constructor(
    private webViewService: WebViewService,
    private theme: ThemeWrapper
  ) {}

  create(map: GoogleMap): GoogleMapsShutdownController {
    return new GoogleMapsShutdownController(this.webViewService, this.theme, map);
  }
}

export class GoogleMapsShutdownController {
  constructor(
    private webViewService: WebViewService,
    private theme: ThemeWrapper,
    private map: GoogleMap
  ) {}

  public async shutdown(): Promise<void> {
    await this.map.destroy();

    //Capacitor's Google Map plugin sets the background color to white. Fix here.
    const color = this.theme.ionColorBackground;
    await this.webViewService.setBackgroundColor(color);
  }
}
